
export const SERVER = process.env.REACT_APP_SERVER_ENDPOINT;
export const SERVER_CHAT = process.env.REACT_APP_SERVER_CHAT_ENDPOINT;

export const REACT_APP_ENVIRONMENT_MODE = process.env.REACT_APP_ENVIRONMENT_MODE;
export const SERVER_DOMAIN = process.env.REACT_APP_SERVER_ENDPOINT;
export const ADMIN_DOMAIN = process.env.REACT_APP_SELF_ENDPOINT;
export const ROLES = {
  ROOT: "ًROOT",
  SUPER_ADMIN: "SUPER_ADMIN",
  HR_ADMIN:'HR_ADMIN',
  HR_PANEL_ADMIN:'HR_PANEL_ADMIN',
  USERS_ADMIN: "USERS_ADMIN",
  UNIT_ADMIN: "UNIT_ADMIN",
  MARKETING_ADMIN: "MARKETING_ADMIN",
  USER_EXPERIMENTAL: "َUSER_EXPERIMENTAL",
  ANBAAR_ADMIN: "ANBAAR_ADMIN",
  SALE_ADMIN: "SALE_ADMIN",
  USER_CRM_SIMPLE:"USER_CRM_SIMPLE" ,
  UNIT_CRM_USER:"UNIT_CRM_USER",
  MANAGER_CRM:"MANAGER_CRM",
  SALE_CRM_ADMIN:"SALE_CRM_ADMIN",


};
export const EditProductPermitions = [
  ROLES.SUPER_ADMIN,
  ROLES.USERS_ADMIN,
  ROLES.SALE_ADMIN,
]

export const CreateProductPermitions = [...EditProductPermitions]